import React from 'react';
import { useParams } from 'react-router-dom';

import SettingRow from '../SettingRow';
import Toggle from 'flow/components/ui-components/Toggle';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import actions from 'flow/actions';
import { saveHeadsetEnabledToStorage } from 'flow/utils/browser-utils';
import { ExtensionKey } from 'flow/types/EntityKeys';

import isElectron from 'is-electron';
import { getAppDownloadUrls, isTeamsFullClient } from 'flow/utils/app-utils';

const HeadsetControls = () => {
    const { embedded, i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();

    const hasHeadsets = useAppSelector((state) =>
        state.headsets.get('enabled'),
    );

    const handleToggle = (value: boolean) => {
        dispatch({
            type: value ? actions.ENABLE_HEADSETS : actions.DISABLE_HEADSETS,
        });

        saveHeadsetEnabledToStorage(extensionKey, value);
    };

    const getInformation = () => {
        if (isElectron()) {
            return i18next.t('media.settings.headsetcontrols.multiple_calls');
        }

        if (isTeamsFullClient(embedded)) {
            return i18next.t(
                'media.settings.headsetcontrols.webapp.teams.disabled',
            );
        }

        const url = getAppDownloadUrls();
        return (
            <>
                {i18next.t('media.settings.headsetcontrols.webapp.disabled')}
                {url ? (
                    <>
                        {' '}
                        <a
                            className="text-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={url.website}
                        >
                            {url.website}
                        </a>
                    </>
                ) : null}
            </>
        );
    };

    return (
        <SettingRow
            information={getInformation()}
            cta={
                <Toggle
                    value={hasHeadsets}
                    onChange={handleToggle}
                    disabled={!isElectron()}
                    text={i18next.t('media.settings.headsetcontrols')}
                />
            }
        >
            {i18next.t('media.settings.headsetcontrols')}
        </SettingRow>
    );
};

export default HeadsetControls;
